:host {
    /**
    * @prop --monaco-editor-width: width of the editor, default is 100%
    * @prop --monaco-editor-height: height of the editor, default is 50vh
    */
    --monaco-editor-width: 100%;
    --monaco-editor-height: 50vh;
}

.editor-container {
  width: var(--monaco-editor-width);
  height: var(--monaco-editor-height);
}